<template>
    <div>
      <el-row :span="2" :offset="2">
        <el-button size="medium"  class="btn" @click="back">返回</el-button>
        <el-button size="medium" type="danger" style="margin-right:30px;margin-bottom: 20px" @click="printPreview()">打印</el-button>
      </el-row>
      <div id="subOutputRank-print" style="margin: auto">
        <template>
            <printHtml :tableData="printData"></printHtml>
        </template>
      </div>
      <el-row>
        <el-col :span="2" :offset="22">
          <el-button size="medium"  style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
          </el-button>
        </el-col>
      </el-row>
    </div>
  </template>
<script>
import { notOrderDetailFun } from 'api/sellOrder';
import http from '@/assets/common/http';
import printHtml from '@/components/sendDocument/printDetail';

export default {
  data() {
    return {
      printData: [],
      pageRouter: sessionStorage.getItem('pageRouter'),
    };
  },
  components: {
    printHtml,
  },
  created() {
    this.salesOrderAuditDetail = JSON.parse(sessionStorage.getItem('salesOrderAudit'));
    this.queryPrintData();
  },
  methods: {
    queryPrintData() {
      const params = {
        ID: Number(this.salesOrderAuditDetail.ID),
      };
      notOrderDetailFun(params).then((result) => {
        if (result[0]) {
          this.printData = result[0].DETAIL;
        } else {
          this.$message.show({ text: '未获取到详情数据，请重试', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    back() {
      window.history.go(-1);
    },
    // 打印
    printPreview() {
      const subOutputRankPrint = document.getElementById('subOutputRank-print');
      const newContent = subOutputRankPrint.innerHTML;
      const oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
      document.body.innerHTML = oldContent;
      this.$router.push({ name: this.pageRouter });
      window.location.reload();
      return false;
    },
  },
};
</script>
<style scoped>
ul {
    list-style: none;
    min-height: 100px;
    padding: 0;
}

li {
    margin-bottom: 0;
    line-height: 25px;
    font-size: 14px;
}

p {
    font-size: 14px;
}

#subOutputRank-print {
    width: 284mm;
}


</style>



// WEBPACK FOOTER //
// src/components/sendDocument/printPreview.vue